import { Animated, Easing } from 'react-native'
import { createStackNavigator } from 'react-navigation'

import Summary from '../components/Screens/Summary'
import BreakingNews from '../components/Screens/BreakingNews'
import PeerInsights from '../components/Screens/PeerInsights'
import OurFinancials from '../components/Screens/OurFinancials'
import HelpManual from '../components/Screens/HelpManual'
import Businesses from '../components/Screens/Businesses'
import SpecialProjects from '../components/Screens/SpecialProjects'
import DealRoom from '../components/Screens/DealRoom'
import ExcoDecision from '../components/Screens/ExcoDecision'
import Treasury from '../components/Screens/Treasury'
import Opex from '../components/Screens/Opex'
import Survey from '../components/Screens/Survey'

const AppNav = createStackNavigator({
  Summary,
  BreakingNews,
  PeerInsights,
  OurFinancials,
  HelpManual,
  Businesses,
  Opex,
  SpecialProjects,
  DealRoom,
  ExcoDecision,
  Treasury,
  Survey
}, {
  headerMode: 'none',
  transitionConfig: () => ({
    transitionSpec: {
      duration: 0,
      timing: Animated.timing,
      easing: Easing.step0
    }
  })
})

export default AppNav
